// Wording for the "Do not contact" control on a Lead Bot conversation. Pure, so every sentence is asserted
// without jsdom. ⚠️ The flag is about the CLUB, not a number: it blocks texts (and, from Stage 3, calls) to
// this phone at THIS club and stops Speed to Lead starting anything for them. It does not affect STOP.

export const DNC_ON_BADGE = 'Do not contact';

export function dncConfirmTitle(setting: boolean): string {
  return setting ? 'Mark this lead as do not contact?' : 'Allow contact with this lead again?';
}

export function dncConfirmBody(setting: boolean, clubName: string | null): string {
  const club = clubName?.trim() || 'this club';
  return setting
    ? `${club} will no longer text this person, and Speed to Lead will not start anything for them. It applies to ${club} only. You can undo it at any time, and both the change and the undo are recorded with your name.`
    : `${club} will be able to text this person again, and Speed to Lead can start things for them. The change is recorded with your name.`;
}

export function dncStateLine(set: boolean, setByName: string | null, setAt: string | null): string {
  if (!set) return 'This lead can be contacted.';
  const who = setByName ? ` by ${setByName}` : '';
  const when = setAt ? ` on ${new Date(setAt).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })}` : '';
  return `Marked do not contact${who}${when}.`;
}
